import { render, staticRenderFns } from "./CallBack.vue?vue&type=template&id=b080e67e&scoped=true&"
import script from "./CallBack.vue?vue&type=script&lang=js&"
export * from "./CallBack.vue?vue&type=script&lang=js&"
import style0 from "./CallBack.vue?vue&type=style&index=0&id=b080e67e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b080e67e",
  null
  
)

component.options.__file = "CallBack.vue"
export default component.exports